import React from "react";
import { useIntl } from "react-intl";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";

export default function InfluencerCityInput({
  selectedInfluencerCountries,
  isDisabled,
  cityValueInput,
  onCityValueInputChange,
  onKeyPress,
}) {
  const intl = useIntl();
  return (
    <div className="audience-search__field">
      <div className="audience-search__input">
        <div className="idh-label idh-label--with-tooltip">
          <IDHFormattedMessage
            id="front_influencer_city"
            defaultMessage="Creator City"
          />
          <MaterialTooltip
            id="front_influencer_city_tooltip"
            content={
              <IDHFormattedMessage
                id="front_influencer_city_tooltip"
                defaultMessage="Here you can specify the city of the creator."
              />
            }
          />
        </div>
        <MaterialTooltip
          id="front_influencer_city_input_tooltip"
          content={
            <IDHFormattedMessage
              id="front_influencer_city_input_tooltip"
              defaultMessage="Before selecting a Creator city, you must select a Creator country."
            />
          }
          contentHidden={selectedInfluencerCountries.length > 0}
        >
          <input
            placeholder={intl.formatMessage({
              id: "front_influencer_city_placeholder",
              defaultMessage: "Enter city",
            })}
            value={cityValueInput}
            onKeyPress={onKeyPress}
            onChange={onCityValueInputChange}
            disabled={isDisabled}
            data-cdt-input="cities"
          />
        </MaterialTooltip>
      </div>
    </div>
  );
}
